import http from '@/services/http';
import { COMM_URL } from '@/services/urls';

// The Communication Center API (celer-backend modules/communication). Like the
// other services, nothing here throws: failures come back as { error }.
const call = async request => {
	try {
		const res = await request();
		return res?.data || { error: true };
	} catch (error) {
		console.log(error);
		return { error: true };
	}
};

const qs = params =>
	Object.entries(params || {})
		.filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== false)
		.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
		.join('&');

const url = (path, params) => `${COMM_URL}${path}${params && qs(params) ? `?${qs(params)}` : ''}`;

export const commApi = {
	me: cityId => call(() => http.get(url('me', { cityId }))),
	contacts: (role, cityId) => call(() => http.get(url('contacts', { role, cityId }))),
	conversations: filters => call(() => http.get(url('conversations', filters))),
	start: body => call(() => http.post(url('conversations'), body)),
	startOrder: (orderSource, orderId) =>
		call(() => http.post(url('order-conversations'), { orderSource, orderId })),
	conversation: id => call(() => http.get(url(`conversations/${id}`))),
	messages: (id, before) => call(() => http.get(url(`conversations/${id}/messages`, { before }))),
	send: (id, body) => call(() => http.post(url(`conversations/${id}/messages`), { body })),
	read: (id, upTo) => call(() => http.post(url(`conversations/${id}/read`), { upTo })),
	setStatus: (id, status) => call(() => http.put(url(`conversations/${id}/status`), { status })),
	settings: () => call(() => http.get(url('settings'))),
	setSettings: (cityId, patch) => call(() => http.put(url(`settings/${cityId}`), patch)),
	permissions: cityId => call(() => http.get(url('permissions', { cityId }))),
	setPermission: body => call(() => http.put(url('permissions'), body)),
	exceptions: cityId => call(() => http.get(url('exceptions', { cityId }))),
	setException: body => call(() => http.put(url('exceptions'), body)),
	audit: filters => call(() => http.get(url('audit', filters))),
	prefs: () => call(() => http.get(url('prefs'))),
	setPrefs: notificationsEnabled => call(() => http.put(url('prefs'), { notificationsEnabled })),
	pushSubscription: (subscription, remove) =>
		call(() => http.post(url('push-subscription'), { subscription, remove })),
};
